import { render, staticRenderFns } from "./ListPendingSecondReports.vue?vue&type=template&id=75751f63&lang=pug&"
import script from "./ListPendingSecondReports.vue?vue&type=script&lang=ts&"
export * from "./ListPendingSecondReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports